import { AlertLevel } from "@dto/alerting.dto";

export enum AlertType {
  PERFORMANCE = 'performance',
  ANOMALY = 'anomaly',
  PING = 'ping',
  PREDICTIVE = "predictive",
}

export interface IValuePerId extends Record<string, number | string> {
}

// Alerts check data up to this many seconds back (collectors lag), so `triggered` timestamps trail the wall clock by it.
export const ALERTING_DATA_DELAY_S = 600;

export const ALERT_CONST = {
  CUSTOM_GROUP_ID: 'CUSTOM_GROUP',
  CUSTOM_GROUP_LABEL: 'Custom Group',
  CIP_CLASS: 'xormon',
  CIP_HW_TYPE: 'customip',
  CIP_LABEL: 'Custom IP'
} as const;

// Declaration order is severity order (lowest to highest) — getAlertLevelIndex relies on it.
export const ALERT_LEVEL = {
  undefined: 'undefined',
  info: 'info',
  minor: 'minor',
  warning: 'warning',
  major: 'major',
  critical: 'critical',
} as const;

export const DETECTION_MODE = {
  "shift_basic": "shift-basic",
  "test-all-on": "test-all-on",
  "test-all-off": "test-all-off",
} as const;

export const PREDICTIVE_MODEL = {
  "auto": "Auto",
  "trend": "Trend",
  "trend_30_days": "30 Day Trend",
  "trend_60_days": "60 Day Trend",
  "trend_120_days": "120 Day Trend",
} as const;

export function getAlertLevelIndex(severity: string) {
  return Object.values(ALERT_LEVEL).indexOf(severity as AlertLevel);
}

// export const ALERT_TYPE = {
//   global: 'global',
//   personal: 'personal',
// } as const;

// export const ALERT_GROUP_TYPE = {
//   storage: 'storage',
//   default: 'default',
//   custom_group: 'custom_group',
// } as const;

export const ALERT_ITEM_TYPE = {
  list: 'list',
  regex: 'regex'
} as const;

export const ALERTING_FREE_LIMIT = 3;

// Mandatory properties defined by class and subsystem
// Example: { storage: { device: ['model', 'version', ...] }, network: { device: [...] } }
export const MandatoryProperties: Record<string, Record<string, string[]>> = {
  storage: {
    device: [
      'model',
      'version',
      'ip_address',
      'serial'],
  },
};


export class CustomIp {
  name: string;
  ip: string;
}
